import React from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import PodcastWidget from 'components_v2/desktop/PodcastWidget';
import RenderInserts from '../../../components/desktop/RenderInsertsV2/RenderInserts';
import s from './GaanaNbt.scss';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

class GaanaNbt extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  loadSection() {
    const { data } = this.props;
    if (data && data.dataUrl) {
      this.loadSectionData(data.dataUrl);
    } else {
      this.setState({
        data,
      });
    }
  }

  loadSectionData = dataUrl => {
    if (!dataUrl) {
      return;
    }

    makeRequest
      .get(dataUrl, { isMobile: false }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          this.setState({
            data: data.data,
          });
        }
      });
  };
  render() {
    const { data } = this.state;
    const { ga4Type, ga4Category } = this.props;
    // if (!Array.isArray(data.items)) {
    //   return null;
    // }

    return (
      <InViewObserver
        inViewCallback={() => {
          this.loadSection();
          if (typeof ga4Type !== 'undefined' && ga4Type !== '') {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: ga4Type,
              category: ga4Category,
            });
          }
        }}
        viewMargin="400px 0px 400px 0px"
      >
        {data &&
          Array.isArray(data.items) && (
            <>
              <span className={s.doubleboder_top} />
              <div className={`${s.gaananbt} podcast_nbt ${data.className}`}>
                {data.items.map(node => {
                  const iframeData = { ...node };
                  iframeData.wu = node.dataUrl;
                  if (node.id && node.id.toLowerCase() === 'gaana') {
                    iframeData.name = '';
                  } else {
                    iframeData.wu = node.dataUrl;
                  }
                  return (
                    <div className={`${s.iframeWrapper}`}>
                      {iframeData.tn &&
                        iframeData.tn === 'podcastwidget' && (
                          <PodcastWidget
                            sectionItem={iframeData}
                            key={iframeData.id}
                            ga4Type={ga4Type}
                            ga4Category={ga4Category}
                          />
                        )}
                      {iframeData.tn &&
                        iframeData.tn === 'iframe' && (
                          <RenderInserts
                            key={`${iframeData.id}_inserts`}
                            data={[iframeData]}
                            lazyload={1}
                            ga4Type={
                              iframeData?.ga4Type
                                ? iframeData?.ga4Type
                                : ga4Type
                            }
                            ga4Category={
                              iframeData?.ga4Category
                                ? iframeData?.ga4Category
                                : ga4Category
                            }
                          />
                        )}
                    </div>
                  );
                })}
              </div>
            </>
          )}
      </InViewObserver>
    );
  }
}

GaanaNbt.propTypes = {
  data: PropTypes.shape({}),
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,
};
GaanaNbt.defaultProps = {
  data: {},
  ga4Type: '',
  ga4Category: '',
};

export default GaanaNbt;
